import LTR from "@brand-icons/global/livechat/livechat-ltr.svg";

import { iconFactory } from "../iconFactory";

export const LivechatIcon = iconFactory("LivechatIcon", LTR);
